export class TripDataReportModel {
  startDateTime: string;
  endDateTime: string;
  distance: string;
  licenseTag: string;
  contractTypeGroup: string;
  instanceHashId:string = '';
  companyHashId:string = '';
  sharedVehicleGroupHashId:string = '';
  driverHashId :  string = '';
  driverName:string;
  organizationHashId: string = '';
  organizationName : string;
  vehicleHashId:string = '';
  instanceName :string;
  groupName :string;
  companyName :string;
  public isDriverSearch: boolean = true;
  fromOdometer:string;
  toOdometer:string;
  fromOdometerFormated:string;
  toOdometerFormated:string;
  distanceFormated:string;
  tripId: string;
  tripComment: string;
  tripCommentBy: string;
  tripCommentByFullname: string;
  tripCommentOn: string;
  }


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/tripdatareport/models/tripdatareport.model.ts